import React from "react";
import { Typography, Container, Box, Grid, Button } from "@mui/material";
import bot from "./Images/person.avif";
import girl from "./Images/hot.jpg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import blaxk from "./Images/blaxk.jpg";
import { useNavigate } from "react-router-dom";
const Summercollection = () => {
  const navigate =useNavigate();
  return (
    <React.Fragment>
      <Container>
        {" "}
        <Typography sx={{ mt: 15 }}>
          <Typography
            sx={{
              fontSize: "2.5rem",
              color: "#022a6b",
              borderBottom: "4px solid black",
              width:{ lg:"35%",md:"35%"},
              borderBottomRightRadius: 20,
              marginLeft: "auto",
            }}
          >
            Summer{" "}
            <span
              style={{
                fontSize: "1.5rem",
                marginTop: 2.2,
                marginLeft: 1,
                color: "black",
              }}
            >
              {" "}
              Collection
            </span>
          </Typography>
        </Typography>
        <Typography sx={{ mt: 3, fontSize: "1.1rem",marginLeft:{lg:86,md:62}  }}>
          We consider your look and comfort on scorching weather.
        </Typography>
        <Box sx={{ mt: 5 }}>
          {" "}
          <Grid spacing={10} container>
            <Grid item lg={6} md={6} xs={12}>
            <Box
  boxShadow={24}
  component="img"
  src={bot}
  sx={{
    borderRadius: "35px",
    mt: 5,
    maxWidth: { lg: 500, md: 350, xs: 350 },
    cursor: "pointer",
    marginLeft: "auto",
    marginRight: "auto",borderLeft:"10px solid #1a193a",
    ":hover": {
      transition: "0.3s",
      transform: "scale(1.05)",
    },
  }}
/>
{" "}
              <Typography sx={{ mt: 4 }}>
                Our main aim is to serve our customer with better quality
                product. We try to understand their needs and provide them
                within a short period of time.
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <Typography sx={{ mt: { lg: 5, md: 5 } }}>
                We provide the largest clothing collection for any season. You
                can choose trendy or classy design according to your
                preferences. Our services are super fast and we update within 24
                hours.
              </Typography>
              <Box sx={{ position: "relative" }}>
                <Box
                  component="img"
                  boxShadow={24}
                  src={girl}
                  sx={{
                    borderRadius: "35px",
                    mt: 4,
                    ml: { lg: 10, md: 10,xs:5 },
                    maxWidth: { lg: 300, md: 300, xs: 300 },
                    position: "absolute",
                    zIndex: 1,
                    cursor: "pointer",borderRight:"10px solid #1a193a",
                    ":hover": {
                      transition: "0.3s",
                      transform: "scale(1.05)",
                    },
                  }}
                />
                <Box
                  component="img"
                  boxShadow={24}
                  src={blaxk}
                  sx={{
                    
                    borderRadius: "35px",
                    mt: 40,
                    maxWidth: { lg: 130, md: 130, xs: 130 },
                    position: "absolute",
                    zIndex: 2,
                    cursor: "pointer",borderLeft:"10px solid #1a193a",
                    ":hover": {
                      transition: "0.3s",
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Button onClick={()=>navigate("/summerclothcollection")}
            varient="contained"
            sx={{
              marginLeft: "auto",
              display: "flex",
              boxShadow: 24,
              borderRadius: 5,

              fontSize: "1rem",

              padding: "8px 20px 8px 20px",
              cursor: "pointer",
              marginTop: { lg: 12, xs: 65, md: 25 },
              marginRight: 3.5,
              bgcolor: "white",
              color: "#022a6b",

              "&:hover": {
                transform: "scale(1.05)",
                transition: "0.2s",
                bgcolor: "#022a6b",
                color: "white",
              },
            }}
          >
            Explore <ArrowForwardIcon />
          </Button>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default Summercollection;
